/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from 'formik';
import { useActions } from 'common/hooks/useActions';
import { ValidationFilterStatistics } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import MultiDropdown from 'components/form/MultiDropdown';
import DateInput from 'components/form/dateInput';
import { useEffect } from 'react';
import { Dayjs } from 'dayjs';

import * as T from 'common/types';
import * as S from './styles';

interface IProps {
  cafeteriaList: { list: T.Pages.CafeteriaListItem[] };
  now?: Dayjs;
}

export default function CafeteriaStatisticsSidebarFilterForm({ cafeteriaList, now }: IProps) {
  const { cafeteriaChartRequestAction, cafeteriaMenuManagementRequestAction } = useActions();

  // const [data, setData] = useState(second)

  useEffect(() => {
    cafeteriaMenuManagementRequestAction({ getAll: true, page: 1, take: 1000 });
  }, []);

  useEffect(() => {
    if (cafeteriaList.list.length)
      cafeteriaChartRequestAction({
        items: cafeteriaList.list.map((item) => item.id),
        date: now
      });
  }, [cafeteriaList.list.length]);

  return (
    <S.Content>
      <Formik
        initialValues={{
          items: cafeteriaList.list as T.Form.ListDropdownItem[],
          date: ''
        }}
        enableReinitialize
        validationSchema={ValidationFilterStatistics}
        onSubmit={(values, { setSubmitting }) => {
          cafeteriaChartRequestAction({
            items: values.items.map((item) => item.id),
            date: values.date || now
          });
          setSubmitting(false);
        }}
        validateOnBlur={true}
      >
        {({ values, errors, touched, handleSubmit, setValues }) => (
          <>
            <MultiDropdown
              label="Items"
              list={cafeteriaList.list}
              onChange={(list: T.Form.ListDropdownItem[]) => {
                setValues({
                  ...values,
                  items: list
                });
              }}
              placeholder="Select or search Items"
              defaultValues={values.items.length ? values.items : cafeteriaList.list}
              // hasSearch
              message={touched.items && (errors.items as string)}
              error={errors.items as unknown as boolean}
              key={cafeteriaList.list.length}
            />

            <S.Field>
              <DateInput
                label="Date"
                onChange={(date) =>
                  setValues({
                    ...values,
                    date
                  })
                }
                defaultDate={values.date || now}
                format="YYYY/MM"
                picker="month"
                message={touched.date && (errors.date as any)}
                error={touched.date && (errors.date as any)}
              />
            </S.Field>

            <S.Field>
              <PrimaryButton onClick={handleSubmit} style={{ width: '100%' }}>
                Apply filter
              </PrimaryButton>
            </S.Field>
          </>
        )}
      </Formik>
    </S.Content>
  );
}
